import { render } from "./VsudLoader.vue?vue&type=template&id=1b9980bd"
import script from "./VsudLoader.vue?vue&type=script&lang=js"
export * from "./VsudLoader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ibrahimisa/Documents/Work/HibSoft/Projects/Frontier-Systems/Projects/geep-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__